/*jshint -W069 */
/**
 * 
 * @class Api
 * @param {(string|object)} [domainOrOptions] - The project domain or options object. If object, see the object's optional properties.
 * @param {string} [domainOrOptions.domain] - The project domain
 * @param {object} [domainOrOptions.token] - auth token - object with value property and optional headerOrQueryName and isQuery properties
 */
var Api = (function() {
    'use strict';

    var Q = require('q');
    var settingsInstance = require('./SettingsInstance.js');
    var customRequest = require('./requestHelper.js').customRequest;
    var mergeQueryParams = require('./requestHelper.js').mergeQueryParams;

    function Api(options) {
        var domain = (typeof options === 'object') ? options.domain : options;
        this.domain = domain ? domain : settingsInstance.baseApiUrl;
        if (this.domain.length === 0) {
            throw new Error('Domain parameter must be specified as a string.');
        }
    }

    /**
     * HTTP Request
     * @method
     * @name Api#request
     * @param {string} method - http method
     * @param {string} path - path
     * @param {string} url
     * @param {object} body - body parameters / object
     * @param {object} headers - header parameters
     * @param {object} queryParameters - querystring parameters
     * @param {object} form - form data object
     * @param {object} deferred - promise object
     */
    Api.prototype.request = customRequest;

    /**
     * Usuń plik
     * @method
     * @name Api#deletePlikiById
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.id - ID pliku
     * @param {string} parameters.token - Token
     */
    Api.prototype.deletePlikiById = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/pliki/{id}',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];

        parameterPath = parameterPath.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('DELETE', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    /**
     * Dodaj plik użytkownika przy dodawaniu warstwy użytkownika
     * @method
     * @name Api#postPlikiUzytkownika
     * @param {object} parameters - method options and parameters
     * @param {file} parameters.file - Plik
     * @param {file} parameters.file2 - Plik
     * @param {file} parameters.file3 - Plik
     * @param {file} parameters.file4 - Plik
     * @param {string} parameters.format - Format danych (shp, gml, kml, gpx, geotiff, geojson, dxf, dwg, dgn, mif, tab, csv, gdb, mdb)
     * @param {string} parameters.kodowanie - Kodowanie znaków (utf-8, windows-1250, iso-8859-2)
     * @param {string} parameters.x - Kolumna x
     * @param {string} parameters.y - kolumna y
     * @param {string} parameters.wkt - kolumna wkt
     * @param {string} parameters.token - Token
     */
    Api.prototype.postPlikiUzytkownika = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/pliki_uzytkownika',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];

        if (parameters['file'] !== undefined) {
            files['file'] = parameters['file'];
        }

        if (parameters['file'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: file'));
            return deferred.promise;
        }

        if (parameters['file2'] !== undefined) {
            files['file2'] = parameters['file2'];
        }

        if (parameters['file3'] !== undefined) {
            files['file3'] = parameters['file3'];
        }

        if (parameters['file4'] !== undefined) {
            files['file4'] = parameters['file4'];
        }

        if (parameters['format'] !== undefined) {
            form['format'] = parameters['format'];
        }

        if (parameters['format'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: format'));
            return deferred.promise;
        }

        if (parameters['kodowanie'] !== undefined) {
            form['kodowanie'] = parameters['kodowanie'];
        }

        if (parameters['kodowanie'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: kodowanie'));
            return deferred.promise;
        }

        if (parameters['x'] !== undefined) {
            form['x'] = parameters['x'];
        }

        if (parameters['y'] !== undefined) {
            form['y'] = parameters['y'];
        }

        if (parameters['wkt'] !== undefined) {
            form['wkt'] = parameters['wkt'];
        }

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('POST', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    return Api;
})();

exports.Api = Api;